import axios from '../axiosInstance';
import { createCrudApi } from '../createCrudApi';

export type HandoverProtocolsGetParams = {
  limit?: number;
  offset?: number;
  ordering?: string;
  search?: string;
  autopsy?: number;
};

export type HandoverProtocol = {
  id: number;
  autopsy: number;
  material_description: string;
  handed_over_at: string | null;
  handed_over_by: number | null;
  received_by: number | null;
  created_at: string;
  created_by: number | null;
};

export type HandoverProtocolPrint = {
  autopsy_protocol_number: string;
  deceased_first_name: string;
  deceased_last_name: string;
  deceased_date_of_birth: string;
  material_description: string;
  handed_over_at: string | null;
  handed_over_by_name: string;
  received_by_name: string;
};

export type HandoverProtocolFormData = Partial<
  Omit<HandoverProtocol, 'id' | 'created_at' | 'created_by'>
>;

export const HandoverProtocolsApi = () => ({
  ...createCrudApi<HandoverProtocol, HandoverProtocolFormData, HandoverProtocolsGetParams>(
    '/v1/handover-protocols/'
  ),

  print: (id: number) =>
    axios.get<Blob>(`/v1/handover-protocols/${id}/print/`, { responseType: 'blob' })
});
